
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_145pa_1dvdr_141",
  "focus-lock": "awsui_focus-lock_145pa_1dvdr_176",
  "calendar": "awsui_calendar_145pa_1dvdr_180",
  "date-picker-container": "awsui_date-picker-container_145pa_1dvdr_196",
  "date-picker-trigger": "awsui_date-picker-trigger_145pa_1dvdr_201",
  "date-picker-input": "awsui_date-picker-input_145pa_1dvdr_205",
  "open-calendar-button": "awsui_open-calendar-button_145pa_1dvdr_210"
};
  